export default __webpack_public_path__ + "static/media/whales_bl.3ab928e7.png";